var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (model) {pug_html = pug_html + "\u003Cdiv class=\"panel\"\u003E\u003Cdiv class=\"panel-heading\"\u003E\u003Cspan class=\"panel-title\"\u003E" + (pug.escape(null == (pug_interp = model.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"panel-body\"\u003E\u003Cdiv class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cdiv data-ref=\"bid-multipliers-view\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["errors-container",model.showRequestError ? 'show' : 'hide'], [false,true]), false, true)) + "\u003E";
// iterate model.errors
;(function(){
  var $$obj = model.errors;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var error = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"error\"\u003E" + (pug.escape(null == (pug_interp = error) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var error = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"error\"\u003E" + (pug.escape(null == (pug_interp = error) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"bulk-edit-container\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"model" in locals_for_with?locals_for_with.model:typeof model!=="undefined"?model:undefined));;return pug_html;};
module.exports = template;